var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 8.66666V5.99999C5.33331 5.64637 5.47379 5.30723 5.72384 5.05718C5.97389 4.80713 6.31302 4.66666 6.66665 4.66666C7.02027 4.66666 7.35941 4.80713 7.60946 5.05718C7.8595 5.30723 7.99998 5.64637 7.99998 5.99999V8.66666",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 7.33334H7.99998",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.6667V12",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 12H18.6667",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 12C17.3334 12 16 16 13.3334 16",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.4595C16.2973 14.9029 16.6923 15.2723 17.1545 15.5393C17.6168 15.8063 18.1341 15.9639 18.6667 16",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 18C10.9797 18 10.6406 17.8595 10.3905 17.6095C10.1405 17.3594 10 17.0203 10 16.6667V9.99999C10 9.64637 10.1405 9.30723 10.3905 9.05718C10.6406 8.80713 10.9797 8.66666 11.3333 8.66666H20.6667C21.0203 8.66666 21.3594 8.80713 21.6095 9.05718C21.8595 9.30723 22 9.64637 22 9.99999V16.6667C22 17.0203 21.8595 17.3594 21.6095 17.6095C21.3594 17.8595 21.0203 18 20.6667 18H19.3333V22L15.3333 18H11.3333Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 12.6667L4.66667 15.3333V11.3333H3.33333C2.97971 11.3333 2.64057 11.1929 2.39052 10.9428C2.14048 10.6928 2 10.3536 2 10V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V6",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTranslate);
export default __webpack_public_path__ + "static/media/message-translate.724c95a4b69d61c5130835bf0641d15a.svg";
export { ForwardRef as ReactComponent };